import { inject } from 'vue';
import { u as useSingleton } from './useSingleton-D8gLr_EB.js';

function createInstance() {
  const config = inject(Symbol.for("FormKitConfig"));
  return config;
}
const useFormKitConfig = useSingleton(createInstance);

export { useFormKitConfig as u };
//# sourceMappingURL=useFormKitConfig-9PFumoqq.js.map
